import React, { useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Bell, CheckCircle, AlertTriangle, Info, Package, Users, Bike, DollarSign, X, Check, Trash2 } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
const notifications = [{
  id: 1,
  type: 'delivery',
  icon: Package,
  color: 'blue',
  title: 'New delivery request',
  message: 'Alice Smith requested a delivery from Downtown to Airport',
  time: '2 min ago',
  read: false,
  actionable: true
}, {
  id: 2,
  type: 'alert',
  icon: AlertTriangle,
  color: 'red',
  title: 'Rider compliance issue',
  message: "Bruce Wayne's license has expired. Account suspended.",
  time: '15 min ago',
  read: false,
  actionable: true
}, {
  id: 3,
  type: 'success',
  icon: CheckCircle,
  color: 'green',
  title: 'Payout completed',
  message: 'Weekly payout of ₦213,375 processed successfully to 342 riders',
  time: '1 hour ago',
  read: false,
  actionable: false
}, {
  id: 4,
  type: 'customer',
  icon: Users,
  color: 'purple',
  title: 'New customer signup',
  message: '12 new customers registered in the last hour',
  time: '1 hour ago',
  read: true,
  actionable: false
}, {
  id: 5,
  type: 'rider',
  icon: Bike,
  color: 'gold',
  title: 'Rider application pending',
  message: 'Sarah Connor submitted application for rider approval',
  time: '2 hours ago',
  read: true,
  actionable: true
}, {
  id: 6,
  type: 'payment',
  icon: DollarSign,
  color: 'green',
  title: 'Suspicious transaction flagged',
  message: 'Transaction TRX-8921 flagged for unusual amount (₦450)',
  time: '3 hours ago',
  read: true,
  actionable: true
}, {
  id: 7,
  type: 'info',
  icon: Info,
  color: 'blue',
  title: 'System maintenance scheduled',
  message: 'Scheduled maintenance on Sunday 2:00 AM - 4:00 AM',
  time: '5 hours ago',
  read: true,
  actionable: false
}, {
  id: 8,
  type: 'delivery',
  icon: Package,
  color: 'blue',
  title: 'Delivery dispute opened',
  message: 'Customer Charlie Brown opened dispute for delivery #FAMO-9274',
  time: '6 hours ago',
  read: true,
  actionable: true
}];
export function Notifications() {
  const [activeTab, setActiveTab] = useState('all');
  const [notificationList, setNotificationList] = useState(notifications);
  const [selectedNotification, setSelectedNotification] = useState<any>(null);
  const unreadCount = notificationList.filter(n => !n.read).length;
  const markAsRead = (id: number) => {
    setNotificationList(prev => prev.map(n => n.id === id ? {
      ...n,
      read: true
    } : n));
  };
  const markAllAsRead = () => {
    setNotificationList(prev => prev.map(n => ({
      ...n,
      read: true
    })));
  };
  const deleteNotification = (id: number) => {
    setNotificationList(prev => prev.filter(n => n.id !== id));
    if (selectedNotification?.id === id) {
      setSelectedNotification(null);
    }
  };
  const filteredNotifications = activeTab === 'all' ? notificationList : activeTab === 'unread' ? notificationList.filter(n => !n.read) : notificationList.filter(n => n.type === activeTab);
  return <div className="space-y-6" data-id="element-651">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-652">
        <div data-id="element-653">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-654">Notifications</h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-655">
            {unreadCount} unread notification{unreadCount !== 1 ? 's' : ''}
          </p>
        </div>
        <button onClick={markAllAsRead} disabled={unreadCount === 0} className="px-4 py-2 bg-famo-gold text-white rounded-lg text-sm font-medium hover:opacity-90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2" data-id="element-656">
          <Check size={16} data-id="element-657" />
          Mark all as read
        </button>
      </div>

      {/* Tabs */}
      <div className="flex border-b border-slate-200 overflow-x-auto" data-id="element-658">
        <button onClick={() => setActiveTab('all')} className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'all' ? 'border-famo-gold text-famo-navy' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-659">
          All
        </button>
        <button onClick={() => setActiveTab('unread')} className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap flex items-center gap-2 ${activeTab === 'unread' ? 'border-famo-gold text-famo-navy' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-660">
          Unread
          {unreadCount > 0 && <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-661">
              {unreadCount}
            </span>}
        </button>
        <button onClick={() => setActiveTab('delivery')} className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'delivery' ? 'border-famo-gold text-famo-navy' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-662">
          Deliveries
        </button>
        <button onClick={() => setActiveTab('alert')} className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'alert' ? 'border-famo-gold text-famo-navy' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-663">
          Alerts
        </button>
        <button onClick={() => setActiveTab('payment')} className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'payment' ? 'border-famo-gold text-famo-navy' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-664">
          Payments
        </button>
      </div>

      {/* Notifications List */}
      <motion.div key={activeTab} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3
    }} className="space-y-3" data-id="element-665">
        {filteredNotifications.length === 0 ? <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-12 text-center" data-id="element-666">
            <Bell size={48} className="text-slate-300 mx-auto mb-4" data-id="element-667" />
            <h3 className="text-lg font-medium text-slate-600 mb-2" data-id="element-668">
              No notifications
            </h3>
            <p className="text-sm text-slate-400" data-id="element-669">You're all caught up!</p>
          </div> : filteredNotifications.map((notification, idx) => {
        const Icon = notification.icon;
        const colorClasses = {
          blue: 'bg-blue-100 text-blue-600',
          red: 'bg-red-100 text-red-600',
          green: 'bg-green-100 text-green-600',
          purple: 'bg-purple-100 text-purple-600',
          gold: 'bg-yellow-100 text-yellow-600'
        }[notification.color] || 'bg-slate-100 text-slate-600';
        return <motion.div key={notification.id} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: idx * 0.05
        }} onClick={() => setSelectedNotification(notification)} className={`bg-white rounded-xl shadow-sm border transition-all cursor-pointer ${notification.read ? 'border-slate-100 hover:border-slate-200' : 'border-famo-gold/30 bg-famo-gold/5 hover:border-famo-gold/50'}`} data-id="element-670">
                <div className="p-4 flex items-start gap-4" data-id="element-671">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${colorClasses}`} data-id="element-672">
                    <Icon size={20} data-id="element-673" />
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-674">
                    <div className="flex items-start justify-between gap-2 mb-1" data-id="element-675">
                      <h3 className={`font-semibold text-slate-900 ${!notification.read ? 'font-bold' : ''}`} data-id="element-676">
                        {notification.title}
                      </h3>
                      <span className="text-xs text-slate-400 whitespace-nowrap" data-id="element-677">
                        {notification.time}
                      </span>
                    </div>
                    <p className="text-sm text-slate-600 mb-2" data-id="element-678">
                      {notification.message}
                    </p>

                    <div className="flex items-center gap-2" data-id="element-679">
                      {!notification.read && <button onClick={e => {
                  e.stopPropagation();
                  markAsRead(notification.id);
                }} className="text-xs text-famo-gold hover:text-famo-gold-dark font-medium flex items-center gap-1" data-id="element-680">
                          <Check size={12} data-id="element-681" />
                          Mark as read
                        </button>}
                      {notification.actionable && <button onClick={e => {
                  e.stopPropagation();
                  setSelectedNotification(notification);
                }} className="text-xs text-blue-600 hover:text-blue-700 font-medium" data-id="element-682">
                          View details →
                        </button>}
                      <button onClick={e => {
                  e.stopPropagation();
                  deleteNotification(notification.id);
                }} className="ml-auto text-xs text-slate-400 hover:text-red-600 flex items-center gap-1" data-id="element-683">
                        <Trash2 size={12} data-id="element-684" />
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>;
      })}
      </motion.div>

      {/* Notification Detail Modal */}
      <AnimatePresence data-id="element-685">
        {selectedNotification && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setSelectedNotification(null)} data-id="element-686">
            <motion.div initial={{
          scale: 0.95,
          y: 20
        }} animate={{
          scale: 1,
          y: 0
        }} exit={{
          scale: 0.95,
          y: 20
        }} onClick={e => e.stopPropagation()} className="bg-white rounded-xl shadow-2xl max-w-lg w-full" data-id="element-687">
              {/* Header */}
              <div className="p-6 border-b border-slate-200 flex justify-between items-start" data-id="element-688">
                <div className="flex items-center gap-3" data-id="element-689">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center ${{
                blue: 'bg-blue-100 text-blue-600',
                red: 'bg-red-100 text-red-600',
                green: 'bg-green-100 text-green-600',
                purple: 'bg-purple-100 text-purple-600',
                gold: 'bg-yellow-100 text-yellow-600'
              }[selectedNotification.color] || 'bg-slate-100 text-slate-600'}`} data-id="element-690">
                    {createElement(selectedNotification.icon, {
                  size: 24
                })}
                  </div>
                  <div data-id="element-691">
                    <h2 className="text-lg font-bold text-slate-900" data-id="element-692">
                      {selectedNotification.title}
                    </h2>
                    <p className="text-xs text-slate-500" data-id="element-693">
                      {selectedNotification.time}
                    </p>
                  </div>
                </div>
                <button onClick={() => setSelectedNotification(null)} className="p-2 hover:bg-slate-100 rounded-lg transition-colors" data-id="element-694">
                  <X size={20} className="text-slate-500" data-id="element-695" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 space-y-4" data-id="element-696">
                <p className="text-slate-700" data-id="element-697">{selectedNotification.message}</p>

                {selectedNotification.actionable && <div className="bg-slate-50 p-4 rounded-lg" data-id="element-698">
                    <h4 className="font-medium text-slate-900 mb-2" data-id="element-699">
                      Suggested Actions
                    </h4>
                    <div className="space-y-2" data-id="element-700">
                      {selectedNotification.type === 'delivery' && <>
                          <button className="w-full bg-famo-gold text-white py-2 rounded-lg text-sm font-medium hover:opacity-90 transition-colors" data-id="element-701">
                            View Delivery Details
                          </button>
                          <button className="w-full bg-white border border-slate-200 text-slate-700 py-2 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-702">
                            Assign Rider
                          </button>
                        </>}
                      {selectedNotification.type === 'alert' && <>
                          <button className="w-full bg-red-50 text-red-700 py-2 rounded-lg text-sm font-medium hover:bg-red-100 transition-colors" data-id="element-703">
                            Review Compliance Issue
                          </button>
                          <button className="w-full bg-white border border-slate-200 text-slate-700 py-2 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-704">
                            Contact Rider
                          </button>
                        </>}
                      {selectedNotification.type === 'rider' && <>
                          <button className="w-full bg-green-50 text-green-700 py-2 rounded-lg text-sm font-medium hover:bg-green-100 transition-colors" data-id="element-705">
                            Approve Application
                          </button>
                          <button className="w-full bg-white border border-slate-200 text-slate-700 py-2 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-706">
                            View Application Details
                          </button>
                        </>}
                      {selectedNotification.type === 'payment' && <>
                          <button className="w-full bg-blue-50 text-blue-700 py-2 rounded-lg text-sm font-medium hover:bg-blue-100 transition-colors" data-id="element-707">
                            Investigate Transaction
                          </button>
                          <button className="w-full bg-white border border-slate-200 text-slate-700 py-2 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-708">
                            View Payment History
                          </button>
                        </>}
                    </div>
                  </div>}

                <div className="flex gap-2 pt-2" data-id="element-709">
                  {!selectedNotification.read && <button onClick={() => {
                markAsRead(selectedNotification.id);
                setSelectedNotification(null);
              }} className="flex-1 bg-slate-100 text-slate-700 py-2 rounded-lg text-sm font-medium hover:bg-slate-200 transition-colors" data-id="element-710">
                      Mark as Read
                    </button>}
                  <button onClick={() => {
                deleteNotification(selectedNotification.id);
                setSelectedNotification(null);
              }} className="flex-1 bg-red-50 text-red-700 py-2 rounded-lg text-sm font-medium hover:bg-red-100 transition-colors" data-id="element-711">
                    Delete
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}